export default __webpack_public_path__ + "static/media/shoes.26a25b78.jpg";